export enum FieldType {
    TextField = 'textfield',
    TextareaField = 'textareafield',
    DropdownField = 'dropdownfield',
    DropdownSelectField = 'dropdownselectfield',
    CheckboxField = 'checkboxfield',
    HiddenField = 'readonlyfield',
    UploadField = 'uploadfield',
    RelationField = 'relationfield',
    TexteditorField = 'texteditorfield'
}
